// extracted by mini-css-extract-plugin
module.exports = {"CountryModal":"styles_CountryModal__ti9I0","footerMessage":"styles_footerMessage__LQnir","linksWrapper":"styles_linksWrapper__pf7Aa","link":"styles_link__cTKcF"};